<template>
    <div>
        <ImpedimentosMultiples
            ref="ImpedimentosMultiples"
            v-if="selectedImpedimentIds.includes(ImpedimentosMultiplesModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            :selectable-impediments="selectableImpediments"
            :selected-impediments="selectedImpediments"
            @add-impediment="$emit('add-impediment', $event)"
            @delete-impediment="$emit('delete-impediment', $event)"
            v-model="ImpedimentosMultiplesModel"
        />
        <DisturbioEmocional
            ref="DisturbioEmocional"
            v-if="selectedImpedimentIds.includes(DisturbioEmocionalModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="DisturbioEmocionalModel"
        />
        <ProblemasDelHabla
            ref="ProblemasDelHabla"
            v-if="selectedImpedimentIds.includes(ProblemasDelHablaModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="ProblemasDelHablaModel"
        />
        <ProblemasEspecificosAprendizaje
            ref="ProblemasEspecificosAprendizaje"
            v-if="selectedImpedimentIds.includes(ProblemasEspecificosAprendizajeModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="ProblemasEspecificosAprendizajeModel"
        />
        <ImpedimentoVisual
            ref="ImpedimentoVisual"
            v-if="selectedImpedimentIds.includes(ImpedimentoVisualModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="ImpedimentoVisualModel"
        />
        <SordoCiego
            ref="SordoCiego"
            v-if="selectedImpedimentIds.includes(SordoCiegoModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="SordoCiegoModel"
        />
        <DiscapacidadIntelectual
            ref="DiscapacidadIntelectual"
            v-if="selectedImpedimentIds.includes(DiscapacidadIntelectualModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            :severity-options="severityOptions"
            v-model="DiscapacidadIntelectualModel"
        />
        <ProblemaAudicion
            ref="ProblemaAudicion"
            v-if="selectedImpedimentIds.includes(ProblemaAudicionModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="ProblemaAudicionModel"                
        />
        <DanioCerebralPorTrauma
            ref="DanioCerebralPorTrauma"
            v-if="selectedImpedimentIds.includes(DanioCerebralPorTraumaModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="DanioCerebralPorTraumaModel"
        />
        <ImpedimentosOrtopedicos
            ref="ImpedimentosOrtopedicos"
            v-if="selectedImpedimentIds.includes(ImpedimentosOrtopedicosModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="ImpedimentosOrtopedicosModel"
        />
        <Autismo
            ref="Autismo"
            v-if="selectedImpedimentIds.includes(AutismoModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            :disorders-options="disordersOptions"
            v-model="AutismoModel"
        />
        <OtrosImpedimentosSalud
            ref="OtrosImpedimentosSalud"
            v-if="selectedImpedimentIds.includes(OtrosImpedimentosSaludModel.id)"
            :is-disabled="isDisabled"
            :options="options"
            v-model="OtrosImpedimentosSaludModel"
        />    
    </div>
</template>
  
<script>
import SordoCiego from './SordoCiego.vue';
import ProblemaAudicion from './ProblemaAudicion.vue';
import ProblemasDelHabla from './ProblemasDelHabla.vue';
import ImpedimentoVisual from './ImpedimentoVisual.vue';
import DisturbioEmocional from './DisturbioEmocional.vue';
import DiscapacidadIntelectual from './DiscapacidadIntelectual';
import DanioCerebralPorTrauma from './DanioCerebralPorTrauma.vue';
import ProblemasEspecificosAprendizaje from './ProblemasEspecificosAprendizaje.vue';
import ImpedimentosOrtopedicos from './ImpedimentosOrtopedicos.vue';
import Autismo from './Autismo.vue';
import OtrosImpedimentosSalud from './OtrosImpedimentosSalud.vue';
import ImpedimentosMultiples from './ImpedimentosMultiples.vue';
import { ImpedimentEnum } from './common/ImpedimentEnum';

export default {
    name: 'ContainerImpediments',
    components: {
        DisturbioEmocional,
        ProblemasDelHabla,
        ProblemasEspecificosAprendizaje,
        ImpedimentoVisual,
        SordoCiego,
        ProblemaAudicion,
        DanioCerebralPorTrauma,
        DiscapacidadIntelectual,
        ImpedimentosOrtopedicos,
        Autismo,
        OtrosImpedimentosSalud,
        ImpedimentosMultiples,
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                severity: null,
                isPartialHearing: null,
            })
        },
        options: {
            type: Array,
            default: () => ([])
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        selectedImpedimentIds: {
            type: Array,
            default: () => []
        },
        severityOptions: {
            type: Array,
            default: () => []
        },
        disordersOptions: {
            type: Array,
            default: () => []
        },
        allImpediments: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            innerModel: null,
            DisturbioEmocionalModel: {
                id: ImpedimentEnum.DisturbioEmocional,
            },
            ProblemasDelHablaModel: {
                id: ImpedimentEnum.ProblemasHabla
            },
            ProblemasEspecificosAprendizajeModel: {
                id: ImpedimentEnum.ProblemasEspecificosAprendizaje,
            },
            ImpedimentoVisualModel:{
                id: ImpedimentEnum.ImpedimentoVisual,
            },
            SordoCiegoModel:{
                id: ImpedimentEnum.SordoCiego,
            },
            DanioCerebralPorTraumaModel:{
                id: ImpedimentEnum.DanioCerebralPorTrauma,
            },
            DiscapacidadIntelectualModel: {
                id: ImpedimentEnum.DiscapacidadIntelectual,
                severity: null,
            },
            ProblemaAudicionModel: {
                id: ImpedimentEnum.ProblemaAudicion,
                isPartialHearing: null,
            },
            ImpedimentosOrtopedicosModel: {
                id: ImpedimentEnum.ImpedimentosOrtopedicos,
            },
            AutismoModel:{
                id: ImpedimentEnum.Autismo,
                disorders: null
            },
            OtrosImpedimentosSaludModel:{
                id: ImpedimentEnum.OtrosImpedimentos
            },
            ImpedimentosMultiplesModel: {
                id: ImpedimentEnum.ImpedimentosMultiples,
            },
        }
    },
    methods: {
        validate() {
            let isValid = true;
            if (this.selectedImpedimentIds.includes(ImpedimentEnum.DisturbioEmocional)) {
                isValid = isValid & this.$refs.DisturbioEmocional.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.ProblemasHabla)) {
                isValid = isValid & this.$refs.ProblemasDelHabla.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.ProblemasEspecificosAprendizaje)) {
                isValid = isValid & this.$refs.ProblemasEspecificosAprendizaje.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.ImpedimentoVisual)) {
                isValid = isValid & this.$refs.ImpedimentoVisual.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.SordoCiego)) {
                isValid = isValid & this.$refs.SordoCiego.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.ProblemaAudicion)) {
                isValid = isValid & this.$refs.ProblemaAudicion.validate();
            }            

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.DanioCerebralPorTrauma)) {
                isValid = isValid & this.$refs.DanioCerebralPorTrauma.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.DiscapacidadIntelectual)) {
                isValid = isValid & this.$refs.DiscapacidadIntelectual.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.ImpedimentosOrtopedicos)) {
                isValid = isValid & this.$refs.ImpedimentosOrtopedicos.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.Autismo)) {
                isValid = isValid & this.$refs.Autismo.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.OtrosImpedimentos)) {
                isValid = isValid & this.$refs.OtrosImpedimentosSalud.validate();
            }

            if (this.selectedImpedimentIds.includes(ImpedimentEnum.ImpedimentosMultiples)) {
                isValid = isValid & this.$refs.ImpedimentosMultiples.validate();
            }
            
            return isValid;
        },
        clearSelection(removedImpediments) {
            //Clear options selection
            this.options.forEach(option => {
                if (removedImpediments.includes(option.impedimentId))
                {
                    const optionIndex = this.options.indexOf(option)
                    this.options[optionIndex].selected = false;
                    
                    this.options[optionIndex].children.forEach(child => {
                        const childIndex = this.options[optionIndex].children.indexOf(child);
                        this.options[optionIndex].children[childIndex].selected = false;
                    });
                }
            });

            //Cleare state props
            if (removedImpediments.includes(ImpedimentEnum.DiscapacidadIntelectual)) {
                this.DiscapacidadIntelectualModel.severity = null;
            }

            if (removedImpediments.includes(ImpedimentEnum.ProblemaAudicion)) {
                this.ProblemaAudicionModel.isPartialHearing = null;
            }

            if (removedImpediments.includes(ImpedimentEnum.Autismo)) {
                this.AutismoModel.disorders = null;
            }
        }
    },
    computed: {
        selectableImpediments() {
            return this.allImpediments.filter(x => !this.selectedImpedimentIds.includes(x.id) && x.id != ImpedimentEnum.SordoCiego);
        },
        selectedImpediments() {
            return this.allImpediments.filter(x => this.selectedImpedimentIds.includes(x.id));
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.innerModel = newValue;
                this.DiscapacidadIntelectualModel.severity = newValue.severity;
                this.ProblemaAudicionModel.isPartialHearing = newValue.isPartialHearing;
                this.AutismoModel.disorders = newValue.disorders;
            }
        },
        innerModel: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
        DiscapacidadIntelectualModel: {
            deep: true,
            handler(newValue) {
                this.innerModel.severity = newValue.severity;
            }
        },
        ProblemaAudicionModel: {
            deep: true,
            handler(newValue) {
                this.innerModel.isPartialHearing = newValue.isPartialHearing;
            }
        },
        AutismoModel:{
            deep: true,
            handler(newValue) {
                this.innerModel.disorders = newValue.disorders;
            }
        },
        selectedImpedimentIds: {
            deep: true,
            handler(newValue, oldValue) {
                //Clear selection when remove impediments
                const removedImpediments = oldValue.filter(x => !newValue.includes(x));
                this.clearSelection(removedImpediments);
            }
        }
    }
}
</script>